'use client';

import { ArrowUpDownIcon } from '@terra/ui-icons';
import type { ListCollection } from '@ark-ui/react';
import { Field } from '../../components/field';
import { Select } from '../../components/select';

type SettingsSelectItem = { label: string; value: string };

export type SettingsSelectFieldProps<
  TItem extends SettingsSelectItem = SettingsSelectItem,
> = {
  label: string;
  collection: ListCollection<TItem>;
  value: string;
  disabled?: boolean;
  onValueChange: (value: string) => void;
};

export function SettingsSelectField<TItem extends SettingsSelectItem>({
  label,
  collection,
  value,
  disabled,
  onValueChange,
}: SettingsSelectFieldProps<TItem>) {
  return (
    <Field.Root disabled={disabled}>
      <Field.Label>{label}</Field.Label>
      <Select.Root
        collection={collection}
        value={[value]}
        positioning={{ sameWidth: true }}
        disabled={disabled}
        onValueChange={({ value: nextValue }) => {
          const selectedValue = nextValue[0];

          if (selectedValue) {
            onValueChange(selectedValue);
          }
        }}
      >
        <Select.Control>
          <Select.Trigger>
            <Select.ValueText />
            <ArrowUpDownIcon size={14} />
          </Select.Trigger>
        </Select.Control>
        <Select.Positioner>
          <Select.Content>
            <Select.ItemGroup>
              {collection.items.map((item) => (
                <Select.Item key={item.value} item={item}>
                  <Select.ItemText>{item.label}</Select.ItemText>
                </Select.Item>
              ))}
            </Select.ItemGroup>
          </Select.Content>
        </Select.Positioner>
      </Select.Root>
    </Field.Root>
  );
}
